
import React, { useEffect, useState } from 'react';

export interface IDropdownListProps {
    options: TDropdownOption[],
    selectedValue: string,
    onValueChanged: any,
}

export type TDropdownOption = {
    value: string,
    label: string
}

const DropdownList = (props: IDropdownListProps) => {
    const [selectedValue, setSelectedValue] = useState("");
    const options = props.options;

    useEffect(() => {
        console.log("value changed", selectedValue);
        props.onValueChanged(selectedValue);
    }, [selectedValue])

    // Returning the DropDownMenu
    return (
        <div className="select-dropdown">
        <select value={selectedValue} onChange={(e) => setSelectedValue(e.target.value)}>
            {options.map((option: TDropdownOption) => (
            <option key={option.value} value={option.value}>
                {option.label}
            </option>
            ))}
        </select>
        </div>
        );
}

export default DropdownList;